/**
 * Centralized error and warning reporting via Sentry.
 * Use instead of console.error/console.warn to avoid exposing data in the browser.
 */

import * as Sentry from "@sentry/react";

export function reportError(error: unknown, context?: Record<string, unknown>): void {
  if (context && Object.keys(context).length > 0) {
    Sentry.withScope((scope) => {
      Object.entries(context).forEach(([key, value]) => {
        scope.setExtra(key, value);
      });
      Sentry.captureException(error);
    });
  } else {
    Sentry.captureException(error);
  }
}

export function reportWarning(message: string, context?: Record<string, unknown>): void {
  if (context && Object.keys(context).length > 0) {
    Sentry.withScope((scope) => {
      Object.entries(context).forEach(([key, value]) => {
        scope.setExtra(key, value);
      });
      Sentry.captureMessage(message, "warning");
    });
  } else {
    Sentry.captureMessage(message, "warning");
  }
}
